import HeroContainer from '../ui/hero-container';
import { Footer } from '../Footer';
import Button from '../ui/button/Button';
import HeaderAlt from '../HeaderAlt';

export default function Waitlist() {
  return (
    <>
      <HeaderAlt />
      <HeroContainer className="relative mb-5 min-h-screen pt-8">
        <div className="container mx-auto space-y-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 text-white">
            <span className="fredoka text-[22px] font-medium leading-[32px] tracking-[-0.22px]">
              <i>We&apos;re launching soon 🚀 </i>
            </span>
          </div>

          <h1 className="hero-title fredokaOne mx-auto max-w-[913px]">
            Join the Waitlist and get a discount
          </h1>

          <p className="fredoka mx-auto mb-3 max-w-[550px] text-center text-[19px] font-medium leading-[32px] tracking-[-0.22px] text-[#678285] md:text-[22px]">
            Be a part of our early journey, help us build the product you need to excel in your
            academics.
          </p>

          {/* CTA Button */}
          <div className="relative !mt-8 ">
            <div className="mx-auto flex max-w-xl flex-col gap-3 lg:flex-row">
              <input
                type="text"
                placeholder={'Your Email Address'}
                className="fredoka  rounded-2xl px-[15px] py-[15px] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] md:py-0 lg:w-[70%]"
              />
              {/* <InputField type="text" placeholder={"Your Email Address"} /> */}
              <div className="">
                <Button label={'Sign Up'} className="w-full lg:w-[189px]" />
              </div>
            </div>
            <img
              className="absolute -top-28 hidden h-[160px] max-w-[220px] lg:right-2 lg:inline xl:right-14"
              alt="nocreditcard"
              src="/images/waitlist/hurry_up.png"
            />
            <img
              className="-top-28 mx-auto mt-4 h-[160px] max-w-[300px] lg:right-2 lg:hidden xl:right-14"
              alt="nocreditcard"
              src="/images/waitlist/hurry_up2.png"
            />
          </div>
        </div>
        <div className="mt-12 px-4 pb-4 md:mt-0">
          <img
            src="/images/waitlist/waitlist-hero.png"
            alt="hero-img"
            className="hidden md:block"
          />
          <img
            src="/images/waitlist/waitlist-hero-mobile.png"
            alt="hero-img"
            className="block w-full md:mt-0 md:hidden"
          />
        </div>
      </HeroContainer>
      <Footer />
    </>
  );
}
